/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { eventType, infigo } from '@dm/live-material-infigo';
import { SWITCH } from 'app/config';
import { FeatureConfig } from 'app/config/feature';

import { HostsStrService } from '../../../../../service/block-service/hosts/hosts-str.service';
import { LunsConst } from '../../../../../service/block-service/lun-group/luns.const';
import { DataTypeE } from '../../../global-search-str.service';
import { InfigoService } from '../../infigo.service';

@Component({
    selector: 'app-source-detail',
    templateUrl: './source-detail.component.html',
    styleUrls: ['./source-detail.component.scss'],
})
export class SourceDetailComponent {
    @Input() detail;
    @Input() icon;
    @Input() baseInfo;
    @Input() capacityPercentData = 0;
    @Input() threSholdList = [];
    @Input() showPercentBar = true;
    @Input() vstoreName = '';
    @Input() event;
    @Input() type = 'lun';
    @Input() loading = false;
    number = Number;

    SWITCH = SWITCH;

    FeatureConfig = FeatureConfig;

    constructor(public str: LunsConst,
        public hostsStrService: HostsStrService,
        public infigoService: InfigoService,
        public i18n: I18nService) {
    }

    click(): void {
        infigo.dispatch(eventType.CLICK_LIST_ITEM, this.event);
    }

    clickvstoreName(): void {
        const vstoreId = this.event.vstoreId || this.event.item.vstoreId || this.detail.vstoreId;
        const eventValue = this.infigoService.transformSearchParams({ id: vstoreId }, DataTypeE.tenant);
        infigo.dispatch(eventType.CLICK_LIST_ITEM, eventValue);
    }
}
